import { render } from "./statement.vue?vue&type=template&id=48cddbef&scoped=true"
import script from "./statement.js?vue&type=script&lang=js&external"
export * from "./statement.js?vue&type=script&lang=js&external"

import "./statement.vue?vue&type=style&index=0&id=48cddbef&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cddbef"]])

export default __exports__